// extracted by mini-css-extract-plugin
export default {"sort":"Sort_sort__0KRdw","color":"Sort_color__ojYlx"};